import CommonObj from "../CommonObj";
import { encryptTimestamp } from "../components/commoncsrf/csrf-common";

const getBrowserIdentity = () => {
  if (typeof navigator === "undefined") return "Unknown";

  const ua = navigator.userAgent || "";

  const edgeMatch = ua.match(/Edg\/(\d+)/i);
  if (edgeMatch) return `Microsoft Edge ${edgeMatch[1]}`;

  const chromeMatch = ua.match(/Chrome\/(\d+)/i);
  if (chromeMatch) return `Google Chrome ${chromeMatch[1]}`;

  const firefoxMatch = ua.match(/Firefox\/(\d+)/i);
  if (firefoxMatch) return `Mozilla Firefox ${firefoxMatch[1]}`;

  const safariMatch = ua.match(/Version\/(\d+).+Safari/i);
  if (safariMatch && !/Chrome|Chromium|Edg/i.test(ua)) return `Safari ${safariMatch[1]}`;

  return "Unknown";
};

const submitSessionAudit = async ({ endpoint, accessToken, userId }) => {
  const formData = new FormData();
  formData.append("UserID", userId ?? "");
  formData.append("IPAddress", "");
  formData.append("UserAgent", getBrowserIdentity());

  const response = await fetch(endpoint, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken || ""}`,
      "X-CSRF-Token": encryptTimestamp(),
    },
    body: formData,
    keepalive: true,
  });

  try {
    return await response.json();
  } catch {
    return null;
  }
};

export const trackUserSessionLogin = async ({ accessToken, userId }) => {
  const result = await submitSessionAudit({
    endpoint: CommonObj?.Endpoints?.UserSessionLogin,
    accessToken,
    userId,
  });
  return result?.sessionID ?? null;
};

export const trackUserSessionLogout = async ({ accessToken, sessionId }) => {
  const formData = new FormData();
  formData.append("SessionID", sessionId ?? "");
  await fetch(CommonObj?.Endpoints?.UserSessionLogout, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken || ""}`,
      "X-CSRF-Token": encryptTimestamp(),
    },
    body: formData,
    keepalive: true,
  });
};
